var _rect, _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_849_36777)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_849_36777)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.9551,
    y: 11.5909,
    width: 32,
    height: 32,
    rx: 6,
    fill: "url(#paint0_linear_849_36777)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.456 27.3531C33.2076 26.5623 33.6652 25.5158 33.6652 24.3679C33.6652 23.7956 33.5514 23.2486 33.3442 22.7458C33.9697 22.4835 34.4091 21.8654 34.4091 21.1447C34.409 20.1862 33.632 19.4092 32.6735 19.4092C31.9826 19.4092 31.3862 19.8129 31.1068 20.3972C30.4617 20.0827 29.73 19.905 28.9545 19.905C28.179 19.905 27.4472 20.0827 26.8021 20.3972C26.5227 19.8129 25.9263 19.4092 25.2355 19.4092C24.277 19.4092 23.4999 20.1862 23.4999 21.1447C23.4999 21.8654 23.9393 22.4835 24.5648 22.7458C24.3575 23.2485 24.2437 23.7956 24.2437 24.3678C24.2437 25.5157 24.7014 26.5623 25.453 27.3531C24.1351 28.5999 22.0192 30.6056 22.5207 32.6115C22.7526 33.5391 23.3576 33.9063 23.998 33.9396C24.0435 32.7526 24.9129 31.8058 25.9793 31.8058C27.0747 31.8058 27.9628 32.8049 27.9628 34.0372C27.9628 34.7384 27.6751 35.3637 27.2255 35.7728C27.9994 35.7728 28.8638 35.7728 28.9545 35.7728C29.1451 35.7728 29.9562 35.7728 30.6835 35.7728C30.2339 35.3637 29.9462 34.7384 29.9462 34.0372C29.9462 32.8049 30.8342 31.8058 31.9297 31.8058C32.996 31.8058 33.8655 32.7526 33.911 33.9395C34.5513 33.9062 35.1564 33.5391 35.3883 32.6115C35.8897 30.6056 33.7739 28.5999 32.456 27.3531ZM25.0537 21.8652C24.7309 21.784 24.4917 21.4927 24.4917 21.1447C24.4917 20.7339 24.8247 20.4009 25.2355 20.4009C25.5723 20.4009 25.8565 20.625 25.948 20.9321C25.6056 21.2013 25.3042 21.5155 25.0537 21.8652ZM30.9379 23.996C31.1434 23.996 31.3098 24.1625 31.3098 24.3678C31.3098 24.5732 31.1434 24.7397 30.9379 24.7397C30.7325 24.7397 30.5661 24.5732 30.5661 24.3678C30.5661 24.1625 30.7325 23.996 30.9379 23.996ZM26.971 23.996C27.1765 23.996 27.3429 24.1625 27.3429 24.3678C27.3429 24.5732 27.1765 24.7397 26.971 24.7397C26.7656 24.7397 26.5991 24.5732 26.5991 24.3678C26.5991 24.1625 26.7656 23.996 26.971 23.996ZM28.9545 28.8307C27.3113 28.8307 25.9793 27.9427 25.9793 26.8472C25.9793 25.7517 27.3113 24.8637 28.9545 24.8637C30.5977 24.8637 31.9297 25.7517 31.9297 26.8472C31.9297 27.9427 30.5976 28.8307 28.9545 28.8307ZM31.9609 20.9321C32.0524 20.625 32.3367 20.4009 32.6735 20.4009C33.0843 20.4009 33.4173 20.734 33.4173 21.1447C33.4173 21.4927 33.178 21.784 32.8553 21.8653C32.6048 21.5155 32.3033 21.2013 31.9609 20.9321Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.948 35.029C26.4273 35.029 26.8158 34.6405 26.8158 34.1613C26.8158 33.682 26.4273 33.2935 25.948 33.2935C25.4688 33.2935 25.0802 33.682 25.0802 34.1613C25.0802 34.6405 25.4688 35.029 25.948 35.029Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9604 35.029C32.4397 35.029 32.8282 34.6405 32.8282 34.1613C32.8282 33.682 32.4397 33.2935 31.9604 33.2935C31.4812 33.2935 31.0926 33.682 31.0926 34.1613C31.0926 34.6405 31.4812 35.029 31.9604 35.029Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9545 25.8555C28.4068 25.8555 27.9628 25.9132 27.9628 26.3513C27.9628 26.7895 28.4068 27.3431 28.9545 27.3431C29.5022 27.3431 29.9462 26.7895 29.9462 26.3513C29.9462 25.9132 29.5022 25.8555 28.9545 25.8555Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_849_36777)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.9551,
    y: 11.5909,
    width: 30,
    height: 15,
    rx: 7.5,
    fill: "url(#paint1_linear_849_36777)",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 15.9551,
    y: 12.5909,
    width: 26,
    height: 7,
    rx: 3.5,
    fill: "url(#paint2_linear_849_36777)",
    fillOpacity: 0.8,
    style: {
      mixBlendMode: "overlay"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_849_36777",
    x: 0.00053215,
    y: 0.0000327826,
    width: 57.9091,
    height: 57.9091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.272727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.05256
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.388235 0 0 0 0 0.564706 0 0 0 0.315 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_849_36777"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36364
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.47727
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.388235 0 0 0 0 0.564706 0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_849_36777",
    result: "effect2_dropShadow_849_36777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_849_36777",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_849_36777",
    x: 8.33008,
    y: 5.96594,
    width: 41.25,
    height: 26.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.8125,
    result: "effect1_foregroundBlur_849_36777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_849_36777",
    x1: 17.8782,
    y1: -4.40906,
    x2: 60.8388,
    y2: 3.82718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE6283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_849_36777",
    x1: 28.9551,
    y1: 11.5909,
    x2: 28.9551,
    y2: 32.2159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_849_36777",
    x1: 28.9551,
    y1: 12.5909,
    x2: 28.9551,
    y2: 22.2159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_849_36777"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.9551,
    y: 11.5909,
    width: 32,
    height: 32,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs);
export default __webpack_public_path__ + "static/media/ss.2bd022b1e8172a43eaef4221ca1b939c.svg";
export { ForwardRef as ReactComponent };